'use client';

import { pagesPath } from '@/lib/$path';
import { pathInfo } from '@/types/pathInfo';
import { SEARCH_TARGET, SEARCH_TARGET_VALUES } from '@/types/types';

export const useSearchTarget = () => {
  const getSearchTarget = (): SEARCH_TARGET_VALUES => {
    if (typeof window === 'undefined') {
      return SEARCH_TARGET.STATION;
    }

    const searchTarget = window.localStorage.getItem(
      pathInfo['/*'].localStorage.searchTarget,
    );
    if (!searchTarget) {
      return SEARCH_TARGET.STATION;
    }
    const findSearchTarget = Object.values(SEARCH_TARGET).find((st) => {
      return st === searchTarget;
    });

    if (!findSearchTarget) {
      return SEARCH_TARGET.STATION;
    }

    return findSearchTarget;
  };

  const getSearchTargetUrl = () => {
    const searchTarget = getSearchTarget();
    if (searchTarget === SEARCH_TARGET.STATION) {
      return pagesPath.app.stations.search.$url().path;
    } else if (searchTarget === SEARCH_TARGET.HOSPITAL) {
      const newSearchParams = new URLSearchParams();
      newSearchParams.set(
        pathInfo[pagesPath.app.stations.search.$url().pathname].searchParams
          .searchTarget,
        searchTarget,
      );
      return `${pagesPath.app.stations.search.$url().path}?${newSearchParams.toString()}`;
    }

    return pagesPath.app.stations.search.$url().path;
  };

  const setSearchTarget = (searchTarget: SEARCH_TARGET_VALUES) => {
    localStorage.setItem(
      pathInfo['/*'].localStorage.searchTarget,
      searchTarget,
    );
  };

  return {
    getSearchTarget,
    getSearchTargetUrl,
    setSearchTarget,
  };
};
